// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StandoutText_wrapper__fPXOO","column":"StandoutText_column__VEIBi","inner":"StandoutText_inner__8gy_E","hasTitle":"StandoutText_hasTitle__6Z8Fj"};